import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

/* Same CSS style as PublishEpisode*/
import '../../css/AppCss/Episode/PublicViewPublishEpisode.css';
import '../../css/AppCss/Episode/ViewEpisode.css';
import '../../css/AppCss/Episode/EpisodeButtons.css';
import '../../../node_modules/video-react/dist/video-react.css';
import '../../css/AppCss/questionPreview.css'
import '../../css/AppCss/gamePreview.css'

import { connect } from 'react-redux';
import propTypes from 'prop-types';
import store from '../../Store'


import { withFirebase } from '../../config';
import { Link, Redirect, withRouter } from 'react-router-dom'

import { deleteStoryPaintingGame, getStoryData } from '../../Actions/StoryActions';
import { deleteSongPaintingGame, getSongData } from '../../Actions/SongActions';
import { deleteEpisodePaintingGame, getEpisodeData } from '../../Actions/EpisodeActions';
import { deleteChannelPaintingGame, getChannelData } from '../../Actions/RadioChannelAction'
import { deleteBookPaintingGame, getBookData } from '../../Actions/ReadWithJeelAction'
import { deletePdfBookPaintingGame, getPdfBookData } from '../../Actions/PdfBookAction'
import { SIGN_IN } from '../../routes';


export class PaintingPreview extends Component {

    constructor(props) {
        super(props);

        console.log(this.props);
    }

    componentDidMount() {
        const { auth } = this.props
        if (!auth.uid) {
            return (<Redirect to={SIGN_IN}></Redirect>)
        }

    }


    handleDeleteImage(e, id) {

        if (this.props.state === "viewStory") {
            deleteStoryPaintingGame(id)
                .then(res => {
                    alert("Painting Game Item Deleted Successfully");
                    let storyId = this.props.match.params.storyId;
                    this.props.getStoryData(storyId);
                })
                .catch(err => {
                    alert(err.response.data.message);
                });
        }

        if (this.props.state === "viewSong") {
            deleteSongPaintingGame(id)
                .then(res => {
                    alert("Painting Game Item Deleted Successfully");
                    let songId = this.props.match.params.songId;
                    this.props.getSongData(songId);
                })
                .catch(err => {
                    alert(err.response.data.message);
                });
        }

        if (this.props.state === "viewEpisode") {
            deleteEpisodePaintingGame(id)
                .then(res => {
                    alert("Painting Game Item Deleted Successfully");
                    let episodeId = this.props.match.params.episodeId;
                    this.props.getEpisodeData(episodeId);
                })
                .catch(err => {
                    alert(err.response.data.message);
                });
        }

        if (this.props.state === "viewChannel") {
            deleteChannelPaintingGame(id)
                .then(res => {
                    alert("Painting Game Item Deleted Successfully");
                    let channelId = this.props.match.params.channelId;
                    this.props.getChannelData(channelId);
                })
                .catch(err => {
                    alert(err.response.data.message);
                });
        }

        if (this.props.state === "viewBook") {
            deleteBookPaintingGame(id)
                .then(res => {
                    alert("Painting Game Item Deleted Successfully");
                    let bookId = this.props.bookId;
                    this.props.getBookData(bookId);
                })
                .catch(err => {
                    alert(err.response.data.message);
                });
        }

        if (this.props.state === "viewPdfBook") {
            let pdfID = this.props.pdfId
            deletePdfBookPaintingGame(id)
                .then(res => {
                    alert("Painting Game Item Deleted Successfully");
                    let bookId = pdfID;
                    this.props.getPdfBookData(bookId);
                })
                .catch(err => {
                    alert(err.response.data.message);
                });
        }
    }



    render() {

        let gamesList = '';
        const { games } = this.props;
        const { state } = this.props;

        if (games !== undefined && games !== null) {

            gamesList = games.length >= 1 ? (games.map(game => {
                return (
                    <div className="col-3 gamePreview">
                        <span onClick={e => this.handleDeleteImage(e, game.id)}><FontAwesomeIcon icon="times" color="#dc6d6d" className="true" /></span>

                        <img class="image_Preview" alt={game.imageUrl} src={game.imageUrl} />
                    </div>
                )
            })
            ) : (<div className="col-12">No games</div>)
        }

        return (
            gamesList
        )
    }
}


const mapStateToProps = state =>
    ({
        auth: state.firebase.auth
    })
export default withRouter(
    connect(
        mapStateToProps, 
        { getStoryData,
             getSongData,
              getEpisodeData,
              getChannelData,
              getBookData,
              getPdfBookData
             })(PaintingPreview));
